import { pageJump } from '@/hooks/useJump';
const pageJump_ = pageJump();
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
export default [
  {
    path: '/IFPageFiftyFourPreLogin',
    name: 'pageFiftyFourPreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageFiftyFour/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageFiftyFourLogin') {
        pageJump_.jump();
      }
      next();
    },
  },
  {
    path: '/IFPageFiftyFourLogin',
    name: 'pageFiftyFourLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageFiftyFour/login.vue'),
  },
  {
    path: '/IFPageFiftyFourLeaveInfo',
    name: 'pageFiftyFourLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageFiftyFour/leaveInfo.vue'),
  },
  {
    path: '/IFPageFiftyFourResult',
    name: 'pageFiftyFourResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageFiftyFour/result.vue'),
  },
  {
    path: '/IFPageFiftyFourLoading',
    name: 'pageFiftyFourLoading',
    component: () => import('@/pages/pageListAll/pageFiftyFour/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageFiftyFourCar',
    name: 'pageFiftyFourCar',
    component: () => import('@/pages/pageListAll/pageFiftyFour/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
];
